export const FETCH_ACTIVITY_LOGS_START = "FETCH_ACTIVITY_LOGS_START";
export const FETCH_ACTIVITY_LOGS_SUCCESS = "FETCH_ACTIVITY_LOGS_SUCCESS";
